module.exports = __webpack_public_path__ + "static/gwc-b541d2a2c4e7e1b40e78a3ed320ea9af.jpeg";